import settings from "../../../configs/settings";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Add } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import { useContext, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import Message from "../../../project/utils/Message";
import ArregloAnteojoCristales from "./ArregloAnteojoCristales";
import ArregloPaseCristales from "./ArregloPaseCristales";
import ArregloServicios from "./ArregloServicios";
import ArregloTratamientos from "./ArregloTratamientos";
import ArregloFornituras from "./ArregloFornituras";
import ArregloObservaciones from "./ArregloObservaciones";
import ArregloTable from "./ArregloTable";
import { formatMoney } from "../../utils/utils"

//
// ################################################################################
//
const Arreglo = () => {
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const {
    expandedAccordionArreglo,
    setExpandedAccordionArreglo,
    disabledAccordionArreglo,
    expandedAccordionArregloAnteojoCristales,
    setExpandedAccordionArregloAnteojoCristales,
    expandedAccordionArregloPaseCristales,
    setExpandedAccordionArregloPaseCristales,
    expandedAccordionArregloServicios,
    setExpandedAccordionArregloServicios,
    expandedAccordionArregloTratamientos,
    setExpandedAccordionArregloTratamientos,
    expandedAccordionArregloFornituras,
    setExpandedAccordionArregloFornituras,
    expandedAccordionArregloObservaciones,
    setExpandedAccordionArregloObservaciones,
    arregloAnteojoCristales,
    arregloArmazonNuevo,
    arregloServiciosRows,
    totalArregloServicios,
    totalArregloServiciosContado,
    arregloTratamientosRows,
    totalArregloTratamientos,
    totalArregloTratamientosContado,
    arregloForniturasRows,
    totalArregloFornituras,
    totalArregloForniturasContado,
    arregloAction,
    limpiaArreglo,
    guardarArregloEnTablaArreglos,
    totalArreglo,
    totalArregloContado,
    gaAction,
  } = useContext(GestionAtencionContext);
  //
  // ################################################################################
  //
  const handleClickGuardarArreglo = () => {
    // valido los datos necesarios del arreglo antes de agregarlo a la tabla de anteojos

    if (arregloAnteojoCristales.arregloAnteojoCristalesDescripcion === "") {
      // si el usuario no ingreso una descripcion del anteojo o de los cristales del cliente
      // sobre los que se va a realizar el arreglo

      setMessage({
        messageText: "Debes ingresar la descripción del anteojo o de los cristales del Cliente",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      arregloServiciosRows.length === 0 &&
      arregloTratamientosRows.length === 0 &&
      arregloForniturasRows.length === 0
    ) {
      // si el usuario no ha ingresado al menos un servicio o al menos un tratamiento o al menos una fornitura
      setMessage({
        messageText:
          "Debes ingresar al menos un servicio, un tratamiento o una fornitura para el arreglo",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    // si no hay errores agrego el arreglo a la tabla de anteojos

    guardarArregloEnTablaArreglos();
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={3} sx={{ m: 1, p: 2 }}>
        <Accordion
          expanded={expandedAccordionArreglo}
          disabled={disabledAccordionArreglo}
          onChange={() => setExpandedAccordionArreglo(!expandedAccordionArreglo)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="arreglo"
          >
            <Typography>Arreglo {arregloAction.codigoArreglo}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
            <Accordion
              expanded={expandedAccordionArregloAnteojoCristales}
              onChange={() =>
                setExpandedAccordionArregloAnteojoCristales(
                  !expandedAccordionArregloAnteojoCristales
                )
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="arreglo-cristales"
              >
                <Typography>Anteojo / Cristales del Cliente</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                {/* Arreglo o Cristales del Cliente */}
                <ArregloAnteojoCristales />
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordionArregloPaseCristales}
              onChange={() =>
                setExpandedAccordionArregloPaseCristales(!expandedAccordionArregloPaseCristales)
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="pase"
              >
                <Typography component={"span"} variant={"body1"}>
                  Pase de cristales
                  {arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaArmazon !== 0 &&
                    !expandedAccordionArregloPaseCristales && (
                      <>
                        <Box
                          sx={{
                            textAlign: "left",
                          }}
                        >
                          Precio de lista:
                          <b>
                            {arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaArmazon.toLocaleString(
                              settings.numericLocales.language,
                              settings.numericLocales.options
                            )}
                          </b>
                          Precio de contado:
                          <b>
                            {arregloArmazonNuevo.arregloArmazonNuevoPrecioVentaContadoArmazon.toLocaleString(
                              settings.numericLocales.language,
                              settings.numericLocales.options
                            )}
                          </b>
                        </Box>
                      </>
                    )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                {/* Cristales OD, OI */}
                <ArregloPaseCristales />
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordionArregloServicios}
              onChange={() =>
                setExpandedAccordionArregloServicios(!expandedAccordionArregloServicios)
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="servicios"
              >
                <Typography component={"span"} variant={"body1"}>
                  Servicios
                  {totalArregloServicios !== 0 && !expandedAccordionArregloServicios && (
                    <>
                      <Box
                        sx={{
                          textAlign: "left",
                        }}
                      >
                        Precio de lista:
                        <b>
                          {totalArregloServicios.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                        </b>
                        Precio de contado:
                        <b>
                          {totalArregloServiciosContado.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                        </b>
                      </Box>
                    </>
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                {/* Arreglos */}
                <ArregloServicios />
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordionArregloTratamientos}
              onChange={() =>
                setExpandedAccordionArregloTratamientos(!expandedAccordionArregloTratamientos)
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="tratamientos"
              >
                <Typography component={"span"} variant={"body1"}>
                  Tratamientos
                  {totalArregloTratamientos !== 0 && !expandedAccordionArregloTratamientos && (
                    <>
                      <Box
                        sx={{
                          textAlign: "left",
                        }}
                      >
                        Precio de lista:
                        <b>
                          {totalArregloTratamientos.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                        </b>
                        Precio de contado:
                        <b>
                          {totalArregloTratamientosContado.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                        </b>
                      </Box>
                    </>
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                {/* Tratamientos */}
                <ArregloTratamientos />
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordionArregloFornituras}
              onChange={() =>
                setExpandedAccordionArregloFornituras(!expandedAccordionArregloFornituras)
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="tratamientos"
              >
                <Typography component={"span"} variant={"body1"}>
                  Fornituras
                  {totalArregloFornituras !== 0 && !expandedAccordionArregloFornituras && (
                    <>
                      <Box
                        sx={{
                          textAlign: "left",
                        }}
                      >
                        Precio de lista:
                        <b>
                          {totalArregloFornituras.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                        </b>
                        Precio de contado:
                        <b>
                          {totalArregloForniturasContado.toLocaleString(
                            settings.numericLocales.language,
                            settings.numericLocales.options
                          )}
                        </b>
                      </Box>
                    </>
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                {/* Fornituras */}
                <ArregloFornituras />
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expandedAccordionArregloObservaciones}
              onChange={() =>
                setExpandedAccordionArregloObservaciones(!expandedAccordionArregloObservaciones)
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="observaciones"
              >
                <Typography>Notas y observaciones</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ borderTop: "1px solid rgba(0, 0, 0, .125)" }}>
                {/* Observaciones */}
                <ArregloObservaciones />
              </AccordionDetails>
            </Accordion>
          </AccordionDetails>

          <Grid container spacing={1}>
            <Grid item sm={6}>
              <Typography
                component="div"
                align="right"
                sx={{
                  p: 1,
                  ml: 2,
                  backgroundColor: "SteelBlue",
                  borderRadius: "5px",
                  fontSize: "1rem",
                  fontWeight: "bold",
                }}
              >
                TOTAL DE LISTA: {formatMoney(totalArreglo)}
              </Typography>
            </Grid>
            <Grid item sm={6}>
              <Typography
                component="div"
                align="right"
                sx={{
                  p: 1,
                  mr: 2,
                  backgroundColor: "SteelBlue",
                  borderRadius: "5px",
                  fontSize: "1rem",
                  fontWeight: "bold",
                }}
              >
                TOTAL DE CONTADO: {formatMoney(totalArregloContado)}
              </Typography>
            </Grid>
          </Grid>

          <Box sx={{ p: 2 }}>
            {gaAction.cu !== "view" && (
              <>
                {/* boton de agregar / actualizar arreglo */}

                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleClickGuardarArreglo}
                  startIcon={arregloAction.cu === "new" ? <Add /> : <EditIcon />}
                >
                  {arregloAction.cu === "new" ? "Agregar" : "Actualizar"} Arreglo
                </Button>
              </>
            )}

            {/* boton de cancelar / cerrar */}

            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              onClick={limpiaArreglo}
              startIcon={<CancelIcon />}
            >
              {gaAction.cu !== "view" ? "Cancelar" : "Cerrar"}
            </Button>
          </Box>
        </Accordion>
      </Paper>

      <ArregloTable />

      {/* >>>> Messages */}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};

export default Arreglo;
